var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto w-11/12 lg:w-4/5 xl:w-3/5 2xl:w-2/4",attrs:{"id":"app"}},[_c('NotificationPermissions'),_c('HeaderBar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }